import type { ChoiceInputVariantProps } from './ChoiceInput.variants';

type Size = NonNullable<ChoiceInputVariantProps['size']>;

/** Left-slot icon size per row size (Figma: 18/20/24/28/28px). */
export const CHOICE_INPUT_ICON_SIZE_FOR: Record<Size, number> = {
  s: 18,
  m: 20,
  l: 24,
  xl: 28,
  '2xl': 28,
};

/**
 * Resolved left-slot icon color per dark-mode. Hex because
 * `lucide-react-native` reads `color` as a prop, not a className. Matches the
 * label: secondary-600 (#525252) light / secondary-400 (#a1a1a1) dark — the
 * palindromic auto-inverted value.
 *
 * On a SELECTED primary-variant row (Figma 4640:16199) the icon re-tones with
 * the text to primary-950 — #2f0d68 light, auto-inverting to primary-50
 * #f5f3ff in dark.
 */
export function resolveChoiceInputIconColor(
  isDark: boolean,
  selectedPrimary = false,
): string {
  if (selectedPrimary) return isDark ? '#f5f3ff' : '#2f0d68';
  return isDark ? '#a1a1a1' : '#525252';
}
